/* eslint-disable max-len */
// Genera el formulario oficial PPR-1061 (Certificado de Acreditación,
// Negociado de la Policía de PR) — uno por asistente — usando la imagen del
// formulario como fondo y superponiendo los datos en sus blancos:
// nombre, fecha del curso, tipo de arma, instructor + núm. de autorización,
// nombre/localización del club, núm. de autorización del club, fecha de
// certificación y número de licencia. Las firmas, seguro social y el sello
// quedan en blanco para llenarse a mano.

function esc(s) {
  return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

// dd-mm-yyyy como indica el formulario
function formatDDMMYYYY(dateOrIso) {
  const d = typeof dateOrIso === 'string' ? new Date(`${dateOrIso}T12:00:00`) : dateOrIso;
  if (!d || Number.isNaN(d.getTime())) return '';
  return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
}

// Tipo de arma: siempre "Pistola" (pedido del cliente)
export function weaponTypeFromCategory() {
  return 'Pistola';
}

export function buildCertificatesHtml({ categoryName, dateISO, attendees, instructor, club }) {
  const bgUrl = `${window.location.origin}/assets/certificates/ppr1061.png`;
  const clubLines = (club?.nameLocation || '')
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);
  const weapon = weaponTypeFromCategory(categoryName);
  // Ambas fechas son el día en que se tomó el curso (pedido del cliente)
  const fechaCurso = formatDDMMYYYY(dateISO);
  const fechaCert = fechaCurso;

  const pages = attendees.map((a) => `
  <div class="page">
    <div class="field nombre">${esc(a.userName)}</div>
    <div class="field fechacurso">${fechaCurso}</div>
    <div class="field arma">${esc(weapon)}</div>
    <div class="field instructor">
      <div>${esc(instructor?.name || '')}</div>
      <div>${esc(instructor?.authorizationNumber || '')}</div>
    </div>
    <div class="field club">
      ${clubLines.map((l) => `<div>${esc(l)}</div>`).join('')}
    </div>
    <div class="field clubauth">${esc(club?.authorizationNumber || '')}</div>
    <div class="field fechacert">${fechaCert}</div>
    <div class="field licencia">${esc(a.licenseNumber || '')}</div>
  </div>`).join('');

  return `<!DOCTYPE html>
<html lang="es">
<head>
<meta charset="utf-8" />
<title>Certificados PPR-1061 — ${esc(categoryName)} — ${esc(dateISO)}</title>
<style>
  @page { size: letter portrait; margin: 0; }
  * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  body { margin: 0; background: #eee; font-family: Arial, Helvetica, sans-serif; }
  .page {
    width: 8.5in; height: 11in;
    margin: 0 auto 16px auto;
    background: #fff url('${bgUrl}') no-repeat center / 100% 100%;
    position: relative;
    page-break-after: always;
  }
  .page:last-child { page-break-after: auto; }
  /* Todo lo que se llena va en bold y mayúsculas (pedido del cliente) */
  .field { position: absolute; transform: translateX(-50%); text-align: center; font-size: 13pt; color: #111; white-space: nowrap; font-weight: 700; text-transform: uppercase; }
  .nombre     { left: 46.5%; top: 27.2%; max-width: 48%; }
  .fechacurso { left: 28%;   top: 42.7%; }
  .arma       { left: 69.5%; top: 42.7%; }
  .instructor { left: 28%;   top: 49.4%; line-height: 1.25; font-size: 12pt; }
  .club       { left: 69.5%; top: 47.6%; line-height: 1.25; font-size: 11.5pt; }
  .clubauth   { left: 69.5%; top: 60.3%; }
  .fechacert  { left: 28%;   top: 69.3%; }
  .licencia   { left: 28%;   top: 75.7%; }
  .printbar { position: fixed; top: 12px; left: 12px; z-index: 9; }
  .printbar button { background: #d40100; color: #fff; border: 0; border-radius: 8px; padding: 10px 18px; font-size: 14px; font-weight: 600; cursor: pointer; }
  @media print { .printbar { display: none; } body { background: #fff; } .page { margin: 0; } }
</style>
</head>
<body>
  <div class="printbar"><button onclick="window.print()">🖨 Imprimir / Guardar PDF</button></div>
  ${pages}
</body>
</html>`;
}

function waitForImages(doc, timeoutMs = 3000) {
  const imgs = Array.from(doc.images || []);
  const pending = imgs.filter((img) => !img.complete).map(
    (img) => new Promise((resolve) => { img.onload = resolve; img.onerror = resolve; })
  );
  return Promise.race([
    Promise.all(pending),
    new Promise((resolve) => { setTimeout(resolve, timeoutMs); }),
  ]);
}

async function printViaIframe(html) {
  const iframe = document.createElement('iframe');
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
  document.body.appendChild(iframe);
  const idoc = iframe.contentDocument || iframe.contentWindow.document;
  idoc.open();
  idoc.write(html);
  idoc.close();
  await waitForImages(idoc);
  iframe.contentWindow.focus();
  iframe.contentWindow.print();
  setTimeout(() => { document.body.removeChild(iframe); }, 60000);
}

export function openCertificates(params) {
  const html = buildCertificatesHtml(params);
  const win = window.open('', '_blank');
  if (win) {
    win.document.open();
    win.document.write(html);
    win.document.close();
  } else {
    printViaIframe(html);
  }
}
